/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$carousel-default-radius: 0 !default;
$carousel-control-width: 48px !default;
$carousel-control-height: 48px !default;
$carousel-control-icon-margin: 1px !default;
$carousel-default-icon-carrier-radius: 14px !default;
$carousel-outside-icon-carrier-radius: 14px !default;
$carousel-indicator-width-small: 16px !default;
$carousel-indicator-height-small: 16px !default;
$carousel-indicator-width-large: 56px !default;
$carousel-indicator-height-large: 16px !default;
$carousel-indicator-radius: 4px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$spaceAroundIndicators: 20px;
$paddingOutside: 80px;
$paddingOutsideTablet: 40px;
$paddingOutsideMobile: 60px;

@import "~@splidejs/splide/dist/css/splide.min.css";

.splide__pagination {
  display: none;
}

.splide__track {
  transition: height 350ms ease-in-out;
}

.splide__slide {
  -webkit-transform: translate3d(0, 0, 0);
}

:host {
  display: block;
  position: relative;

  // @include slotted-margins("*:not([slot])");
}

* {
  box-sizing: border-box;
}

.#{$prefix}carousel {
  position: relative;
  width: 100%;

  &:focus {
    outline: none;
  }

  &:focus-within {
    outline: none;
  }

  .#{$prefix}indicators {
    position: relative;
    width: 100%;
    display: flex;

    &.#{$prefix}left {
      justify-content: flex-start;
    }

    &.#{$prefix}center {
      justify-content: center;
    }

    &.#{$prefix}right {
      justify-content: flex-end;
    }

    &.#{$prefix}hidden {
      visibility: hidden;
      opacity: 0;
      display: none;
    }

    .#{$prefix}indicators-inner {
      position: relative;
      width: auto;
      padding: $spaceAroundIndicators 0 $spaceAroundIndicators 0;
      margin: 0 $spaceAroundIndicators 0 $spaceAroundIndicators;
      visibility: visible;
      opacity: 1;
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      gap: 8px;
    }

    &.#{$prefix}indicators-inside {
      position: absolute;
      width: auto;
      max-width: 100%;
      height: auto;
      left: 50%;
      transform: translateX(-50%);
      bottom: 6px;
      padding-top: 0;
      justify-content: center;

      &.#{$prefix}left {
        left: 0px;
        transform: translateX(0%);

        .#{$prefix}indicator {
          &:first-child {
            margin-left: 0;
          }
        }
      }

      &.#{$prefix}center {
        left: 50%;
        transform: translateX(-50%);
      }

      &.#{$prefix}right {
        left: unset;
        right: 0px;
        transform: translateX(0%);

        .#{$prefix}indicator {
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .#{$prefix}slides {
    position: relative;
    width: 100%;
    height: auto;
    border-radius: $carousel-default-radius;

    .#{$prefix}control-wrapper {
      position: absolute;
      bottom: var(--stickyControlCenterPosition, 50%);
      transform: translateY(50%);
      visibility: hidden;
      opacity: 0;
      z-index: 1;
      transition: visibility 300ms ease-in-out, opacity 300ms ease-in-out, top 50ms linear;

      &.#{$prefix}visible {
        visibility: visible;
        opacity: 1;
      }

      &.#{$prefix}prev {
        left: $spaceAroundIndicators;
      }

      &.#{$prefix}next {
        right: $spaceAroundIndicators;
      }

      &.#{$prefix}fixed {
        position: fixed;

        &.#{$prefix}prev {
          left: calc(var(--stickyControlLeftPosition) + $spaceAroundIndicators) !important;
        }

        &.#{$prefix}next {
          right: unset;
          left: calc(var(--stickyControlRightPosition) - $spaceAroundIndicators) !important;
          transform: translateX(-100%) translateY(50%);
        }
      }
    }

    .#{$prefix}slides-inner {
      position: relative;
      width: 100%;
      height: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &.#{$prefix}control-style-outside {
    .#{$prefix}slides {
      padding-left: $paddingOutside;
      padding-right: $paddingOutside;

      .#{$prefix}control-wrapper {
        &.#{$prefix}prev {
          float: left;
          z-index: 1;
          left: 0;
          transform: translateY(50%);
        }

        &.#{$prefix}next {
          float: right;
          z-index: 1;
          right: 0;
          transform: translateY(50%);
        }
      }

      .#{$prefix}control-wrapper {
        &.#{$prefix}fixed {
          &.#{$prefix}prev {
            left: var(--stickyControlLeftPosition) !important;
          }

          &.#{$prefix}next {
            right: unset;
            left: var(--stickyControlRightPosition) !important;
            transform: translateX(-100%) translateY(50%);
          }
        }
      }
    }

    .#{$prefix}indicators {
      padding-left: calc($paddingOutside - $spaceAroundIndicators);
      padding-right: calc($paddingOutside - $spaceAroundIndicators);

      &.#{$prefix}indicators-inside {
        padding-left: $paddingOutside;
        padding-right: $paddingOutside;
      }

      .#{$prefix}indicators-inner {
        @include for-size(phone) {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
  }

  .#{$prefix}control-wrapper-mobile-outside {
    position: absolute;
    left: 0;
    bottom: 0;
    bottom: var(--stickyControlBottomPosition, 0);
    display: none;
    flex-direction: row;
    gap: 8px;
    padding: 12px 0px 0px 0px;

    &.#{$prefix}fixed {
      position: fixed;
      left: var(--stickyControlLeftPosition);
    }
  }
}

/***********************************************
 * Indicator Styles
 ***********************************************/

.#{$prefix}indicator {
  position: relative;
  width: $carousel-indicator-width-large;
  height: $carousel-indicator-height-large;
  display: flex;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: fill 0.15s ease-in-out, background-color 0.15s ease-in-out, transform 0.15s ease-in-out;
  outline: none;
  background: v(indicatorColor);
  border-radius: $carousel-indicator-radius;
  flex-shrink: 0;

  &:focus {
    // @include focusBorder(v(indicatorActColor));
    transform: scale(0.8);
    background-color: v(indicatorHoverColor);

    &.#{$prefix}act {
      transform: scale(1);
    }
  }

  &:hover {
    background: v(indicatorHoverColor);
  }

  &.#{$prefix}act {
    background: v(indicatorActColor);
  }

  @include for-size(phone) {
    width: $carousel-indicator-width-small;
    height: $carousel-indicator-height-small;
  }

  &.#{$prefix}small {
    width: $carousel-indicator-width-small;
    height: $carousel-indicator-height-small;
  }
}

/***********************************************
 * Control Styles
 ***********************************************/

.#{$prefix}control {
  width: $carousel-control-width;
  height: $carousel-control-height;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;

  &:focus {
    .#{$prefix}icon-carrier {
      @include focusBorder(v(controlColorBright));
      border-radius: $carousel-default-icon-carrier-radius;
    }
  }

  .#{$prefix}icon-carrier {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.15s ease-in-out;
    display: block;

    .#{$prefix}carrier {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: v(controlColorBright);
      transition-property: background-color, fill;
      transition-duration: 0.15s;
      transition-timing-function: ease-in-out;
      border-radius: $carousel-default-icon-carrier-radius;
    }

    .#{$prefix}icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: v(controlIconColorBright);
      transition-property: color, fill;
      transition-duration: 0.15s;
      transition-timing-function: ease-in-out;
    }
  }

  &.#{$prefix}prev {
    .#{$prefix}icon-carrier {
      .#{$prefix}icon {
        margin-left: -$carousel-control-icon-margin;
      }
    }
  }

  &.#{$prefix}next {
    .#{$prefix}icon-carrier {
      .#{$prefix}icon {
        margin-left: $carousel-control-icon-margin;
      }
    }
  }

  &.#{$prefix}dark {
    .#{$prefix}icon-carrier {
      .#{$prefix}carrier {
        background-color: v(controlColorDark);
      }

      .#{$prefix}icon {
        color: v(controlIconColorDark);
      }
    }
  }

  &:hover {
    .#{$prefix}icon-carrier {
      .#{$prefix}carrier {
        background-color: v(controlHoverColor);
      }

      .#{$prefix}icon {
        color: v(controlHoverIconColor);
      }
    }

    &.#{$prefix}prev {
      .#{$prefix}icon-carrier {
        transform: translateX(-5px);
      }
    }

    &.#{$prefix}next {
      .#{$prefix}icon-carrier {
        transform: translateX(+5px);
      }
    }
  }

  &.#{$prefix}inactive {
    opacity: 0.3;
    filter: grayscale(1);
    cursor: default;

    &:hover {
      .#{$prefix}icon-carrier {
        transform: translateX(0);
      }
    }
  }

  &.#{$prefix}control-style-outside {
    .#{$prefix}icon-carrier {
      .#{$prefix}carrier {
        background-color: v(outsideControlColor);
        border-radius: $carousel-outside-icon-carrier-radius;
      }

      .#{$prefix}icon {
        color: v(outsideControlIconColor);
      }
    }

    &:focus {
      .#{$prefix}icon-carrier {
        @include focusBorder(v(outsideControlColor));
        border-radius: $carousel-default-icon-carrier-radius;
      }
    }

    &:hover {
      .#{$prefix}carrier {
        background-color: v(outsideControlHoverColor);
      }

      .#{$prefix}icon {
        color: v(outsideControlHoverIconColor);
      }
    }
  }
}

:host(.container-breakpoint-943) {
  .#{$prefix}carousel {
    &.#{$prefix}control-style-outside {
      .#{$prefix}slides {
        @include for-size(tablet) {
          padding-left: $paddingOutsideTablet;
          padding-right: $paddingOutsideTablet;

          .#{$prefix}control-wrapper {
            overflow: hidden; // avoid page horizontal page scroll

            &.#{$prefix}prev {
              transform: translateX(-50vw) translateY(50%);
              left: 50% !important;
              padding: 6px 6px 6px 0px; // keep outline visible
            }

            &.#{$prefix}next {
              transform: translateX(50vw) translateY(50%);
              right: 50%;
              left: unset !important;
              padding: 6px 0px 6px 6px; // keep outline visible
            }
          }
        }
      }

      .#{$prefix}indicators {
        @include for-size(tablet) {
          padding-left: calc($paddingOutsideTablet - $spaceAroundIndicators);
          padding-right: calc($paddingOutsideTablet - $spaceAroundIndicators);

          &.#{$prefix}indicators-inside {
            padding-left: calc($paddingOutsideTablet);
            padding-right: calc($paddingOutsideTablet);
          }
        }

        @include for-size(phone) {
          padding-left: calc($paddingOutsideMobile - $spaceAroundIndicators);
          padding-right: calc($paddingOutsideMobile - $spaceAroundIndicators);

          &.#{$prefix}indicators-inside {
            padding-left: calc($paddingOutsideMobile);
            padding-right: calc($paddingOutsideMobile);
          }
        }
      }
    }
  }

  .#{$prefix}control {
    &.#{$prefix}control-style-outside {
      @include for-size(tablet) {
        width: calc($carousel-control-width - 8px);

        &.#{$prefix}prev {
          .#{$prefix}icon-carrier {
            border-radius: 0 $carousel-outside-icon-carrier-radius $carousel-outside-icon-carrier-radius 0;

            .#{$prefix}carrier {
              border-radius: 0 $carousel-outside-icon-carrier-radius $carousel-outside-icon-carrier-radius 0;
            }
          }
        }

        &.#{$prefix}next {
          .#{$prefix}icon-carrier {
            border-radius: $carousel-outside-icon-carrier-radius 0 0 $carousel-outside-icon-carrier-radius;

            .#{$prefix}carrier {
              border-radius: $carousel-outside-icon-carrier-radius 0 0 $carousel-outside-icon-carrier-radius;
            }
          }
        }
      }

      .#{$prefix}indicators {
        @include for-size(phone) {
          padding-left: calc($paddingOutsideMobile - $spaceAroundIndicators);
          padding-right: calc($paddingOutsideMobile - $spaceAroundIndicators);
        }
      }
    }
  }
}

:host(.container-breakpoint-640) {
  .#{$prefix}carousel {
    &.#{$prefix}control-style-outside {
      padding-bottom: 60px;

      .#{$prefix}control-wrapper-mobile-outside {
        display: none;

        &.#{$prefix}visible {
          display: inline-flex;
        }
      }

      .#{$prefix}slides {
        padding-left: 0;
        padding-right: 0;

        .#{$prefix}control-wrapper {
          display: none;
        }
      }

      .#{$prefix}indicators {
        justify-content: flex-start !important;
        padding-left: 0;
        padding-right: 0;

        &.#{$prefix}indicators-inside {
          padding-left: 0;
          padding-right: 0;
          bottom: calc(6px + 60px);
        }
      }
    }

    .#{$prefix}indicators {
      .#{$prefix}indicators-inner {
        margin-left: 0;
        margin-right: 0;
      }

      &.#{$prefix}indicators-inside {
        .#{$prefix}indicators-inner {
          margin-left: $spaceAroundIndicators;
          margin-right: $spaceAroundIndicators;
        }
      }
    }

    .#{$prefix}indicator {
      width: $carousel-indicator-width-small;
      height: $carousel-indicator-height-small;
    }
  }
}
